import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { baseSidebarElement } from './baseSidebarElement';
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
const SidebarLink = styled(NavLink) `
  ${baseSidebarElement}
`;
export default SidebarLink;
